import { Subject } from "modules/NewClientSurvey/common"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

export function getServiceGroupFromSurvey(groups: ServicesGroup[]) {
    const subject = SurveyResultsStorage.subject
    if (subject === Subject.Child || subject === Subject.Myself) {
        return groups.find((group) => group.family === false)
    }
    if (subject === Subject.Family) {
        return groups.find((group) => group.family === true)
    }
}
